module.exports = __webpack_public_path__ + "static/media/images-3.0f074f47.png";